import { render } from "./orePool.vue?vue&type=template&id=1e12cafe"
import script from "./orePool.vue?vue&type=script&lang=js"
export * from "./orePool.vue?vue&type=script&lang=js"

import "./orePool.vue?vue&type=style&index=0&id=1e12cafe&lang=css"

import exportComponent from "D:\\code\\dapp-wallet\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__